import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';


interface signsState {
    popUpTreatmentSuesModel: {
        show: boolean;
        type: number;
    };
    handlerTreatmentPopUp: {treatmentData: any, show: boolean};
    signingData: any[];
    signingRidersData: any[];
}

const initialState: signsState = {
    popUpTreatmentSuesModel: {
        show: false,
        type: 0
    },
    handlerTreatmentPopUp: {treatmentData: null, show: false},
    signingData: [],
    signingRidersData: [],

}

export const signsSlice = createSlice({
    name: 'signsSlice',
    initialState,
    reducers: {
        setPopUpTreatmentSignsModel: (state, action: PayloadAction<{show: boolean; type: number;}>) => {
            state.popUpTreatmentSuesModel = action.payload;
        },
        setHandlerTreatmentPopUp: (state, action: PayloadAction<{treatmentData: any, show: boolean;}>) => {
            state.handlerTreatmentPopUp = action.payload;
        },
        setSigningData: (state, action: PayloadAction<any[]>) => {
            state.signingData = action.payload;
        },
        setSigningRidersData: (state, action: PayloadAction<any[]>) => {
            state.signingRidersData = action.payload;
        },
    },
})
export const { setPopUpTreatmentSignsModel, setHandlerTreatmentPopUp, setSigningData,  setSigningRidersData} = signsSlice.actions
export default signsSlice.reducer